import { render, staticRenderFns } from "./CompanyJobs.vue?vue&type=template&id=bc34f990&"
import script from "./CompanyJobs.vue?vue&type=script&lang=ts&"
export * from "./CompanyJobs.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyJobs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports